import { render } from "./ThinkTankAdvancedSearch.vue?vue&type=template&id=2afb4e12&scoped=true"
import script from "./ThinkTankAdvancedSearch.vue?vue&type=script&lang=js"
export * from "./ThinkTankAdvancedSearch.vue?vue&type=script&lang=js"

import "./ThinkTankAdvancedSearch.vue?vue&type=style&index=0&id=2afb4e12&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2afb4e12"

export default script